import { createContext, useContext } from 'react';
import type { ChipSize } from './tokens';

export const ChipContext = createContext<ChipSize | null>(null);

/** Read the parent `<Chip>`'s size. Falls back to `'md'` with a dev warning
 *  if used outside a Chip — the DS sub-components (Avatar, Flag, Glyph)
 *  are designed to live inside a Chip. */
export const useChipSize = (): ChipSize => {
  const size = useContext(ChipContext);
  if (size === null) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(
        'DS: Avatar/Flag/Glyph must be rendered inside <Chip>. Falling back to size="md".',
      );
    }
    return 'md';
  }
  return size;
};
